export const getYoYTrend = (current, previous) => {
  if (previous === 0) return current > 0 ? "↑" : "";
  return current > previous ? "↑" : current < previous ? "↓" : "";
};
